import { css } from '@emotion/core';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors/index';
import { MediaQueries } from '../../../styles/Grid';

export const containerPaddingCss = {
  padding: '64px 0',
  [MediaQueries.md]: {
    padding: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    padding: '160px 0',
  },
};

export const containerMarginCss = {
  margin: '64px 0',
  [MediaQueries.md]: {
    margin: '96px 0',
  },
  [MediaQueries.lgAndUp]: {
    margin: '160px 0',
  },
};

export const articleContainerCss = css({
  marginBottom: 59,
});

export const title = css(typography.effra34, {
  fontWeight: fontWeights.medium,
  marginBottom: 44,
  color: colorsPalette.grey,
});

export const mediaTitle = css(typography.effra22, {
  color: colorsPalette.grey,
  fontWeight: fontWeights.regular,
  marginBottom: 10,
  marginTop: 0,
  [MediaQueries.md]: {
    marginBottom: 16,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 20,
    paddingRight: 20,
    minHeight: 96,
  },
  [MediaQueries.xl]: {
    minHeight: 62,
  },
});

export const mediaDescription = css(typography.effra16, {
  color: colorsPalette.grey80,
  fontWeight: fontWeights.regular,
  marginBottom: 19,
  [MediaQueries.mdAndUp]: {
    marginBottom: 29,
  },
  [MediaQueries.lgAndUp]: {
    minHeight: 62,
  },
});
